import { createAsyncThunk } from '@reduxjs/toolkit';

import { billAPI } from '@/modules/bill/api';
import { namespace } from '@/modules/bill/namespace';

import { setBills } from '../actions';

const loadBills = createAsyncThunk(
  `${namespace}/load-bills`,
  async ({ limit, offset }: { limit: number; offset: number }, { dispatch }) => {
    const bills = await billAPI.fetchBills({ limit, offset });

    dispatch(setBills(bills));

    return bills;
  },
);

export { loadBills };
